import { useWebsiteSettings } from 'client/store'
import { getWebsiteStylesTypographyHeading } from 'src/editor/store/website-settings/website-settings-selector'
import { DEFAULT_LINE_HEIGHT } from 'src/shared/constants/default-line-height'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'
import { useCalculateHeadingFontSize } from './use-calculate-heading-font-size'

export const useCalculateHeadingLineHeight = ({
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
}: {
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
}) => {
  const {
    lineHeight: globalLineHeight,
    mobileLineHeight: globalMobileLineHeight,
  } = useWebsiteSettings(getWebsiteStylesTypographyHeading) || {}

  const { calculatedFontSize } = useCalculateHeadingFontSize({
    fontSize,
    mobileFontSize,
  })

  const computedLineHeight = Math.round(
    DEFAULT_LINE_HEIGHT * (calculatedFontSize.desktop as number),
  )

  const computedMobileLineHeight = Math.round(
    DEFAULT_LINE_HEIGHT * (calculatedFontSize.mobile as number),
  )

  return {
    calculatedLineHeight: getCalculatedProperty({
      desktopProperty: lineHeight,
      mobileProperty: mobileLineHeight,
      globalDesktopProperty: globalLineHeight || computedLineHeight,
      globalMobileProperty: globalMobileLineHeight || computedMobileLineHeight,
    }),
    globalLineHeight,
    globalMobileLineHeight,
  }
}
